import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import DeleteModal from 'pages/parts/DeleteModal'
import HintIcon from 'pages/parts/HintIcon'
import { GET, POST, PUT, DELETE, httpOk } from 'helpers/api'

// Группы основных средств: в карточке выбирают «Транспорт», и срок подставляется сам.
// Общие группы (с готовыми сроками) заводит Mison, клиент добавляет свои.
function Groups({ onChange }) {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [form, setForm] = useState(null)
	const [modalDelete, setModalDelete] = useState(false)
	const [deleteId, setDeleteId] = useState(null)

	async function getData() {
		const response = await GET('/finance/fixed-assets/groups', {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	async function save(e) {
		e.preventDefault()
		const response = form.id
			? await PUT('/finance/fixed-assets/groups/' + form.id, form, { loader: true })
			: await POST('/finance/fixed-assets/groups', form, { loader: true, notification: true })
		if (httpOk(response)) {
			setForm(null)
			getData()
			onChange()
		}
	}

	async function deleteItem() {
		const response = await DELETE('/finance/fixed-assets/groups/' + deleteId, {}, { loader: true })
		if (httpOk(response)) {
			setModalDelete(false)
			getData()
			onChange()
		}
	}

	useEffect(() => {
		getData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<div className="card">
			<div className="card-body">
				<div className="d-flex mb-3">
					<span className="text-muted vertical-center">{t('fa_groups_hint')}</span>
					<button className="btn btn-primary ms-auto"
						onClick={() => setForm({ 'id': null, 'name': '', 'method': 'linear', 'life_months': '' })}>
						{t('add')}
					</button>
				</div>

				<div className="table-responsive">
					<table className="table table-bordered mb-0">
						<thead>
							<tr>
								<th style={{ 'width': '40%' }}>{t('name2')}</th>
								<th>{t('fa_method')}</th>
								<th className="text-end">{t('fa_life_months')}</th>
								<th className="text-end">{t('fa_assets_count')}</th>
								<th style={{ 'width': '80px' }}></th>
							</tr>
						</thead>
						<tbody>
							{data.map(item => (
								<tr key={item.id}>
									<td>
										{item.name}
										{item.is_shared && <span className="text-muted"> · {t('fa_group_shared')}</span>}
									</td>
									<td>{item.method === 'none' ? t('fa_not_depreciated') : t('fa_method_linear')}</td>
									<td className="text-end">
										{item.life_months ? `${item.life_months} (${Math.round(item.life_months / 12 * 10) / 10} ${t('fa_years_short')})` : '—'}
									</td>
									<td className="text-end">{item.assets_count}</td>
									<td className="text-center text-nowrap">
										{!item.is_shared &&
											<>
												<i className="uil uil-pen me-2" style={{ 'cursor': 'pointer' }}
													onClick={() => setForm({ 'id': item.id, 'name': item.name, 'method': item.method, 'life_months': item.life_months || '' })}></i>
												<i className="uil uil-times text-danger" style={{ 'cursor': 'pointer' }}
													onClick={() => { setDeleteId(item.id); setModalDelete(true) }}></i>
											</>
										}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>

			<Modal show={!!form} animation={false} centered onHide={() => setForm(null)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('fa_group')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{form &&
						<form onSubmit={save} autoComplete="off">
							<div className="form-group">
								<label>
									{t('name2')}<span className="required-mark">*</span>
									<HintIcon text={t('fa_hint_group_name')} />
								</label>
								<input type="text" className="form-control" value={form.name}
									onChange={(e) => setForm({ ...form, 'name': e.target.value })} />
							</div>
							<div className="row">
								<div className="form-group col-md-6">
									<label>
										{t('fa_method')}
										<HintIcon text={t('fa_hint_method')} />
									</label>
									<select className="form-select" value={form.method}
										onChange={(e) => setForm({ ...form, 'method': e.target.value })}>
										<option value="linear">{t('fa_method_linear')}</option>
										<option value="none">{t('fa_not_depreciated')}</option>
									</select>
								</div>
								{form.method === 'linear' &&
									<div className="form-group col-md-6">
										<label>
											{t('fa_life_months')}<span className="required-mark">*</span>
											<HintIcon text={t('fa_hint_group_life')} />
										</label>
										<input type="text" className="form-control" value={form.life_months}
											onChange={(e) => setForm({ ...form, 'life_months': e.target.value.replace(/[^0-9]/g, '') })} />
									</div>
								}
							</div>
							<div className="d-flex w-100 mt-3 gap-2">
								<button type="button" className="btn btn-outline-warning w-100" onClick={() => setForm(null)}>{t('cancel')}</button>
								<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
							</div>
						</form>
					}
				</Modal.Body>
			</Modal>

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>
		</div>
	)
}

export default Groups
